
import { useCountryMutations, CountryMutationResult } from './mutations/useCountryMutations';
import { useLeagueMutations, LeagueMutationResult } from './mutations/useLeagueMutations';
import { useYearMutations, YearMutationResult } from './mutations/useYearMutations';
import { useSaveStateMutations, SaveStateMutationResult } from './mutations/useSaveStateMutations';

export interface UploadMutationsResult extends 
  CountryMutationResult,
  LeagueMutationResult,
  YearMutationResult,
  SaveStateMutationResult {}

export const useUploadMutations = (
  resetForm: () => void,
  refetchLeagues: () => void,
  refetchYears: () => void,
  selectedCountry: string
): UploadMutationsResult => {
  // Import mutations from separate hook files
  const { addCountryMutation } = useCountryMutations();
  const { addLeagueMutation } = useLeagueMutations(selectedCountry);
  const { addYearMutation } = useYearMutations();
  const { saveStateMutation } = useSaveStateMutations(resetForm);

  return {
    addCountryMutation,
    addLeagueMutation,
    addYearMutation,
    saveStateMutation
  };
};
